import { atom } from "recoil";

export const paginationAtom = atom({
  key: "paginationAtom",
  default: {
    first: 0,
    rows: 10,
    page: 1,
    sortfield: null,
    sortorder: -1,
    totalRecords: 0,
    filters: {
      selectedCategory: null,
      selectedUnderCategory: null,
      active: null,
      reference: null,
      nameProduct: null,
      remise: null
    }
  },
});

export const totalProductsAtom = atom({
  key: "totalProductsAtom",
  default: 0,
})

